(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-collection-root]');
    if (!root) return;

    var toggle = root.querySelector('.collection-layout__filters-toggle');
    var backdrop = root.querySelector('.collection-layout__filters-backdrop');
    var closeBtn = root.querySelector('.collection-filters-panel__close');

    function openFilters() {
      root.classList.add('collection-layout--filters-open');
      document.body.classList.add('collection-filters-open');
      document.body.style.overflow = 'hidden';
      if (backdrop && typeof window.showModalBackdrop === 'function') {
        window.showModalBackdrop(backdrop);
      }
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          root.classList.add('collection-layout--filters-animating');
        });
      });
    }

    function closeFilters() {
      root.classList.remove('collection-layout--filters-animating');
      if (backdrop && typeof window.hideModalBackdrop === 'function') {
        window.hideModalBackdrop(backdrop, function() {});
      }
      setTimeout(function() {
        root.classList.remove('collection-layout--filters-open');
        document.body.classList.remove('collection-filters-open');
        document.body.style.overflow = '';
      }, 300);
    }

    if (toggle) {
      toggle.addEventListener('click', function() {
        if (root.classList.contains('collection-layout--filters-open')) {
          closeFilters();
        } else {
          openFilters();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeFilters);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeFilters);
    }

    var filterDetails = root.querySelectorAll('details.collection-filter');
    var mobileQuery = window.matchMedia('(max-width: 900px)');

    function applyAccordionState() {
      filterDetails.forEach(function(detail) {
        if (mobileQuery.matches) {
          if (!detail.hasAttribute('data-has-active')) {
            detail.removeAttribute('open');
          }
        } else {
          detail.setAttribute('open', '');
        }
      });
    }

    applyAccordionState();
    mobileQuery.addEventListener('change', applyAccordionState);

    filterDetails.forEach(function(detail) {
      detail.querySelector('.collection-filter__summary').addEventListener('click', function(e) {
        if (!mobileQuery.matches) {
          e.preventDefault();
        }
      });
    });

    var sortSheet = root.querySelector('[data-sort-sheet]');
    var sortSelect = root.querySelector('#CollectionSort');

    if (sortSheet && sortSelect) {
      var sortBackdrop = sortSheet.querySelector('.collection-sort-sheet__backdrop');
      var sortCloseBtn = sortSheet.querySelector('.collection-sort-sheet__close');
      var sortSaveBtn = sortSheet.querySelector('[data-sort-save]');
      var sortForm = sortSelect.closest('form');

      function openSortSheet() {
        sortSheet.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (sortBackdrop && typeof window.showModalBackdrop === 'function') {
          window.showModalBackdrop(sortBackdrop);
        }
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            sortSheet.classList.add('collection-sort-sheet--animating');
          });
        });
      }

      function closeSortSheet() {
        sortSheet.classList.remove('collection-sort-sheet--animating');
        if (sortBackdrop && typeof window.hideModalBackdrop === 'function') {
          window.hideModalBackdrop(sortBackdrop, function() {});
        }
        setTimeout(function() {
          sortSheet.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }, 300);
      }

      sortSelect.addEventListener('mousedown', function(e) {
        if (mobileQuery.matches) {
          e.preventDefault();
          openSortSheet();
        }
      });

      sortSelect.addEventListener('touchstart', function(e) {
        if (mobileQuery.matches) {
          e.preventDefault();
          openSortSheet();
        }
      });

      if (sortCloseBtn) sortCloseBtn.addEventListener('click', closeSortSheet);
      if (sortBackdrop) sortBackdrop.addEventListener('click', closeSortSheet);

      if (sortSaveBtn) {
        sortSaveBtn.addEventListener('click', function() {
          var checked = sortSheet.querySelector('.collection-sort-sheet__radio:checked');
          if (checked && sortSelect) {
            sortSelect.value = checked.value;
            closeSortSheet();
            setTimeout(function() {
              sortForm.submit();
            }, 350);
          }
        });
      }
    }

    root.querySelectorAll('[data-tooltip-modal]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var modalId = trigger.getAttribute('data-tooltip-modal');
        var modal = document.getElementById(modalId);
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'false');
        var bd = modal.querySelector('.modal-base__backdrop');
        if (bd && typeof window.showModalBackdrop === 'function') {
          window.showModalBackdrop(bd);
        }
      });
    });

    function closeTooltipModal(modal) {
      if (!modal) return;
      var bd = modal.querySelector('.modal-base__backdrop');
      if (bd && typeof window.hideModalBackdrop === 'function') {
        window.hideModalBackdrop(bd, function() {});
      }
      modal.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[data-filter-tooltip-dismiss]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var modal = btn.closest('.modal-base');
        closeTooltipModal(modal);
      });
    });

    document.querySelectorAll('[data-filter-tooltip-apply]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filterValue = btn.getAttribute('data-filter-tooltip-apply');
        var modal = btn.closest('.modal-base');
        closeTooltipModal(modal);
        var form = root.querySelector('.collection-layout__filters-form');
        if (!form) return;
        var checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function(cb) {
          if (cb.value === filterValue) {
            cb.checked = true;
          }
        });
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });

    var form = root.querySelector('.collection-layout__filters-form');
    if (!form) return;

    form.addEventListener('submit', function() {
      var dimFilters = form.querySelectorAll('[data-dimension-filter]');
      dimFilters.forEach(function(wrapper) {
        var minInput = wrapper.querySelector('[data-dimension-min]');
        var maxInput = wrapper.querySelector('[data-dimension-max]');
        var checkboxes = wrapper.querySelectorAll('[data-dimension-value]');
        var hasMin = minInput.value !== '';
        var hasMax = maxInput.value !== '';

        if (!hasMin && !hasMax) {
          checkboxes.forEach(function(cb) { cb.checked = false; });
        } else {
          var minVal = hasMin ? parseFloat(minInput.value) : -Infinity;
          var maxVal = hasMax ? parseFloat(maxInput.value) : Infinity;
          checkboxes.forEach(function(cb) {
            var val = parseFloat(cb.getAttribute('data-dimension-value'));
            cb.checked = (val >= minVal && val <= maxVal);
          });
        }

        minInput.removeAttribute('name');
        maxInput.removeAttribute('name');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
